//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import util from '@/libs/util'
	import wxjssdk from '@/libs/wxjssdk.mixin'
    import { Icon}  from 'vant'
	export default{
		mixins: [ wxjssdk ],
        components: {
            [Icon.name]: Icon
        },
		props: {
//			src: {
//				type: String,
//				default: ''
//			},
//			duration: {
//				type: String,
//				default: '0'
//			},
			file: {
				type: Object,
				default: ()=>{
					return {
						file_url: '',
						duration: '0',
						_is_wx_file: false
					}
				}
			},
			active: {
				type: Boolean,
				default: false
			},	//控制播放、暂停
            is_qsjy: {
                type: Boolean,
				default: false
            }
		},
		data () {
			return {
				isPlaying: false,
//				true_duration: Math.ceil(this.file.duration||0),
                intDuration: '',
                nowDuration: '00:00',
                codeInterval: null,
                seconds: 0,
                total_seconds: 0,
				lastX: 0,
				lastY: 0,
                now_seconds: 0,
                currentTime: 0,
                is_touchmove: false,
                progress: '0%',
                progress_bg_width: 0
			}
		},
		watch: {
			active: function (val) {
				if(val){
					this.play()
				}else{
					this.ended()
				}				
			},
		},
		created () {
			if(!this.file.duration||this.file.duration==0){
				this.get_duration()				
			}else{
                this.intDuration = this.transTime(this.file.duration)
                this.total_seconds = this.file.duration
            }		
		},
		methods: {
            handletouchmove: function(event) {
				let currentX = event.changedTouches[0].pageX;
				let currentY = event.changedTouches[0].pageY;
				let tx = currentX - this.lastX;
				let ty = currentY - this.lastY;

				//左右方向滑动
				if (Math.abs(tx) > Math.abs(ty)) {
                    let seconds = parseInt(Math.abs(tx) / this.progress_bg_width * this.total_seconds)
                    let currentTime = 0

                    if(tx > 0){
                        currentTime = this.now_seconds + seconds
                        if(currentTime > this.total_seconds){
                            currentTime = this.total_seconds
                        }
                    }else if(tx < 0){
                        currentTime = this.now_seconds - seconds
                        if(currentTime < 0){
                            currentTime = 0
                        }
                    }
                    
                    this.currentTime = currentTime
                    this.progress = (currentTime / this.total_seconds * 100) + '%'
				}
			},
			handletouchstart: function(event) {
                if(this.progress_bg_width == 0){
                    this.progress_bg_width = this.$refs.progress_bg.clientWidth
                }
                this.now_seconds = this.seconds
                this.is_touchmove = true
				this.lastX = event.changedTouches[0].pageX;
				this.lastY = event.changedTouches[0].pageY;
			},
			handletouchend: function(event) {
                this.$refs.player.currentTime = this.seconds = this.currentTime
                this.nowDuration = this.transTime(this.seconds)
				this.is_touchmove = false
			},
			togglePlay () {
				if(!this.isPlaying){					
					this.play()
                    if(this.is_qsjy){
                        this.codeInterval = setInterval(() => {
					    	this.seconds++;
					    	this.nowDuration = this.transTime(this.seconds)
                            if(this.total_seconds != 0 && !this.is_touchmove){
                                this.progress = (this.seconds / this.total_seconds * 100) + '%'
                            }
                            if(this.seconds >= this.total_seconds){
                                clearInterval(this.codeInterval)
                            }
					    }, 1000);
                    }
				}else{
					this.stop()
                    if(this.is_qsjy){
                        clearInterval(this.codeInterval)
                    }
				}
			},
			play () {
				this.onVoicePlayEnd(this.file.file_url)
				.then(()=>{
					this.stop()
				})
				
				this.isPlaying = true
				if(this.file._is_wx_file){
					this.playVoice(this.file.file_url)
				}
	            this.$refs.player.play()
	            
		    },
		    stop () {
		    	this.isPlaying = false
		    	if(this.file._is_wx_file){
					this.stopVoice(this.file.file_url)
				}
	            this.$refs.player.pause()
		    },
		    ended () {
		    	this.$refs.player.currentTime = 0

                if(this.is_qsjy){
                    this.seconds = 0
                    this.nowDuration = '00:00'
                    this.progress = '0%'
                    clearInterval(this.codeInterval)
                }

		    	this.isPlaying = false
		    	this.$refs.player.pause()
		    },
		    get_duration () {
		    	let uri = '/api/open/voice_duration?url='+this.file.file_url+'?avinfo'
				this.$http.get(uri)
				.then(response=>{
					this.file.duration = Math.floor(response.body.data.format.duration)
                    this.intDuration = this.transTime(this.file.duration)
                    if(this.intDuration != '' && this.is_qsjy){
                        let array = this.intDuration.split(':')
                        let second = parseInt(array[0]) * 60 + parseInt(array[1])
                        this.total_seconds = second
                    }
				},response=>{
					console.log(response.body.message||'获取mp3时长错误')
				})				
			},
            transTime(time) {
                let duration = parseInt(time);
                let minute = parseInt(duration/60);
                let sec = duration%60+'';
                let isM0 = ':';

                if(minute == 0){
                    minute = '00';
                }else if(minute < 10 ){
                    minute = '0'+minute;
                }
                if(sec.length == 1){
                    sec = '0'+sec;
                }

                return minute+isM0+sec
            }
		}
	}



// WEBPACK FOOTER //
// ./src/components/SmallVoice.vue